export default __webpack_public_path__ + "static/media/love.31a5d714.svg";